module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/4-1279ed3662698fc198f963a6de753806.jpg";